import { Money } from '../../../types';
import { currentCurrency } from '../../../utils';
import { handleAction } from 'redux-actions';
import { CheckoutState } from '../reducers';
import { setOrderPrice } from './actions';
import { OrderPriceQueryQuery } from '@websky/graphql';

const zeroPrice: Money = {
	amount: 0,
	currency: currentCurrency
};

export const orderPriceReducer = handleAction<CheckoutState['orderPrice'], OrderPriceQueryQuery['OrderPrice']>(
	setOrderPrice,
	(_, action) => action.payload,
	{
		price: {
			aeroexpress: zeroPrice,
			airticket: zeroPrice,
			baggage: zeroPrice,
			charge: zeroPrice,
			insurance: zeroPrice,
			meals: zeroPrice,
			seats: zeroPrice,
			total: zeroPrice
		},
		priceToPay: {
			aeroexpress: zeroPrice,
			airticket: zeroPrice,
			baggage: zeroPrice,
			charge: zeroPrice,
			insurance: zeroPrice,
			meals: zeroPrice,
			seats: zeroPrice,
			total: zeroPrice
		}
	}
);
